import { useEffect, useRef } from 'react'
import TagManager from 'react-gtm-module'
import { generatePath, useParams } from 'react-router-dom'
import { useActivePoolContext } from '../context/active-pool-context'
import { useGetMe } from './queries/me/use-get-me'

export function useConstructLinkWithPool(route: string) {
  const params = useParams()
  const { activePool } = useActivePoolContext()
  const { data: me, isLoading } = useGetMe()
  const hasTrackedMissingPools = useRef(false)

  const usersPools = me?.activePools?.length
    ? me.activePools
    : me?.profitCenterPools

  const hasMissingPools =
    !isLoading && me && (!usersPools || usersPools.length === 0)

  useEffect(() => {
    if (hasMissingPools && !hasTrackedMissingPools.current) {
      hasTrackedMissingPools.current = true
      TagManager.dataLayer({
        dataLayer: {
          event: 'internal_click',
          click_type: 'missing_pools_redirect',
          requested_route: route,
          user_email: me?.email,
          is_internal: me?.isInternal,
        },
      })
    }
  }, [hasMissingPools, route, me])

  if (!usersPools || usersPools.length === 0) {
    return '/404'
  }

  if (params.pool) {
    return generatePath(route, {
      pool: params.pool,
    }).toLowerCase()
  }

  if (activePool) {
    return generatePath(route, {
      pool: activePool,
    }).toLowerCase()
  }

  return generatePath(route, {
    pool: usersPools[0].toLocaleLowerCase(),
  }).toLowerCase()
}
